@if (isDataAvailable) {
<div id="chart">
  <div class="chart-header">
    <h2 class="chart-title">{{ performanceData.title }}</h2>

    <div class="date-picker">
      <mat-form-field class="hidden-picker" appearance="fill">
        <mat-date-range-input [rangePicker]="picker">
          <input
            matStartDate
            [(ngModel)]="startDate"
            (ngModelChange)="onDateChange()"
          />
          <input
            matEndDate
            [(ngModel)]="endDate"
            (ngModelChange)="onDateChange()"
          />
        </mat-date-range-input>

        <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
        <mat-date-range-picker #picker></mat-date-range-picker>
      </mat-form-field>

      <button class="date-range-display" (click)="picker.open()">
        {{ displayRange }}
        <mat-icon>arrow_drop_down</mat-icon>
      </button>
    </div>
  </div>

  <div class="line-chart-container">
    <app-line-graph-chart [data]="performanceData"></app-line-graph-chart>
  </div>
</div>

} @else {
<div class="message">
  <p>No hay datos para mostrar :(</p>
</div>
}
